import React, { FC, ReactElement, ReactNode } from "react";
import GenerateReport from "../../pages/generate-report";

interface IProps {
  location?: TLocation;
  children: ReactNode;
}

export const ScoreReportWrapper: FC<IProps> = ({ location, children }) => {
  return (
    <div
      className="report"
    >
      <GenerateReport />
    </div>
  );
};
